import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  Box,
  Grid,
  Typography,
  TextField,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Select,
  MenuItem,
  Button,
  FormControl,
  InputLabel,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { IoMdSave } from "react-icons/io";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import PhotoUploader from "../components/AddProduct/PhotoUploader";
import ProductVariant from "../components/AddProduct/ProductVariant";
import productService from "../services/productService";
import { validateProduct } from "../utils/validation";
import useAlert from "../hooks/useAlert";
import { categoryService } from "../services/categoryService";
import NestedCategorySelect from "../components/AddProduct/CategorysSelect";
import { getbrands } from "../redux/actions/BrandAction";
import brandSevice from "../services/BrandService";

const AddProductPage = () => {
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);
  const userId = useSelector((state) => state?.auth?.user?.id);

  const [productDetails, setProductDetails] = useState({
    productName: "",
    modelCode: "",
    barcode: "",
    supplierBarcode: "",
    stock: "",
    vat: "",
    category: "",
    brand: "",
  });
  const [description, setDescription] = useState("");
  const [piyasaFiyati, setPiyasaFiyati] = useState("");
  const [satisFiyati, setSatisFiyati] = useState("");
  const [marketplaceValues, setMarketplaceValues] = useState({});
  const [photos, setPhotos] = useState([]);
  const [variantData, setVariantData] = useState({
    rows: [],
    variants: [],
    prices: {},
  });
  const [barcode, setBarcode] = useState("");
  const [expanded, setExpanded] = useState("panel2");
  const [marketplaces, setMarketplaces] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [searchText, setSearchText] = useState(null);
  const [loading, setLoading] = useState(false);
  const { showSuccessProductAdded, showErrorProductAdded } = useAlert();

  // useEffect(() => {
  //     handleVariantsChange(variantData.rows, variantData.variants);
  // }, [photos]);

  useEffect(() => {
    if (variantData?.variants?.length > 0) {
      clearPhotos();
    }
  }, [variantData]);

  const clearPhotos = () => {
    setPhotos([]);
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const handleInputChangeCategory = (e) => {
    const { name, value } = e.target;
    setProductDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  useEffect(() => {
    const fetchMarketAndEcommercePlaces = async () => {
      try {
        const marketResponse = await productService.fetchMarketPlaces();

        const marketData = Array.isArray(marketResponse.data.data)
          ? marketResponse.data.data
          : marketResponse.data.marketplaces || [];

        const ecommerceResponse = await productService.fetchEcommercePlaces();

        const ecommerceData = Array.isArray(ecommerceResponse.data.data)
          ? ecommerceResponse.data.data
          : ecommerceResponse.data.marketplaces || [];

        const combinedData = [
          ...marketData.map((item) => ({ ...item, source: "marketplace" })),
          ...ecommerceData.map((item) => ({ ...item, source: "ecommerce" })),
        ];
        const formattedMarketplaces = combinedData.map((item) => ({
          id: item.id,
          name: item.name,
          color: item.colorCode,
          fields: item.fields || ["Piyasa(Liste Fiyatı)", "Satış Fiyatı"],
          source: item.source,
        }));

        setMarketplaces(formattedMarketplaces);
      } catch (error) {
        console.error("Error fetching marketplace data:", error);
      }
    };
    fetchCategories();
    fetchMarketAndEcommercePlaces();
  }, [token]);
  const [categories, setCategories] = useState([]);
  const fetchCategories = async () => {
    try {
      const isUpperCategorys = true;
      const response = await categoryService.getCategoriesApiForDropdown(
        token,
        1,
        searchText,
        userId
      );

      const fetchedCategories = response.data?.data?.data.map((category) => ({
        id: category.id,
        name: category.name,
        parentId: category.parentId || null,
      }));

      setCategories(fetchedCategories);
    } catch (error) {
      console.error("Kategoriler alınırken bir hata oluştu:", error);
    }
  };

  const dispatch = useDispatch();
  const authUserId = useSelector((state) => state?.auth?.user?.id);
  const [brandsData, setBrandsData] = useState([]);
  useEffect(() => {
    if (authUserId) {
      dispatch(getbrands(authUserId, token));
    }
  }, []);

  //const brands = useSelector(state => state?.brands);
  const getBrand = async () => {
    var response = await brandSevice.getBrandForDropdown(userId);
    setBrandsData(response?.data?.data?.data);
  };
  useEffect(() => {
    getBrand();
    //setBrandsData(brands?.brands?.data)
  }, []);
  useEffect(() => {
    const updatedValues = marketplaces.reduce((acc, marketplace) => {
      acc[marketplace.name] = {
        "Piyasa(Liste Fiyatı)": piyasaFiyati,
        "Satış Fiyatı": satisFiyati,
      };
      return acc;
    }, {});
    setMarketplaceValues(updatedValues);
  }, [piyasaFiyati, satisFiyati]);

  const handleVariantsChange = (rows, variants) => {
    console.log("handleVariantsChange", rows);
    if (!variants || variants.length === 0) {
      setVariantData({ rows: [], variants: [] });
      return;
    }

    let combinations = variants[0].options.map((option) => [
      { name: variants[0].name, option },
    ]);
    for (let i = 1; i < variants.length; i++) {
      const tempCombinations = [];
      combinations.forEach((combination) => {
        variants[i].options.forEach((option) => {
          tempCombinations.push([
            ...combination,
            { name: variants[i].name, option },
          ]);
        });
      });
      combinations = tempCombinations;
    }

    const updatedRows = combinations.map((combination, index) => ({
      ...(rows[index] || {}),
      combination,
      photos: rows[index]?.photos || [],
    }));

    setVariantData({ rows: updatedRows, variants });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProductDetails((prev) => ({ ...prev, [name]: value }));

    setFormErrors((prevErrors) => {
      if (value === "") {
        return { ...prevErrors, [name]: `${name} cannot be empty` };
      }
      const { [name]: removed, ...errors } = prevErrors;
      return errors;
    });
  };

  const handleDescriptionChange = (value) => setDescription(value);

  const handlePhotosChange = (uploadedPhotos) => {
    setPhotos(uploadedPhotos);
  };

  const generateMainId = (row, userId) => {
    const datePart = new Date()
      .toISOString()
      .replace(/[-:.TZ]/g, "")
      .slice(0, 14);
    const userPart = (userId || "0").toString().padStart(3, "0");
    const combinationPart = Array.isArray(row?.combination)
      ? row.combination
          .map((attr) => attr.option)
          .join("")
          .replace(/\s+/g, "")
          .slice(0, 4)
      : "00";

    return (datePart + userPart + combinationPart).slice(0, 15); // 15 karakterlik unique bir ID
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const errors = validateProduct(
      productDetails,
      barcode,
      piyasaFiyati,
      satisFiyati,
      description
    );
    setFormErrors(errors);
    if (Object.keys(errors).length > 0) return;
    console.log("variantData.rows", variantData.rows);
    try {
      const variantRows =
        variantData?.rows?.length > 0 ? variantData.rows : [{}];
      const productAddDTOs = variantRows.map((row) => {
        const productMainId = generateMainId(row, userId); // productMainId için unique ID
        const stockCode = productDetails.modelCode || ""; // Model kodu stockCode yerine gidiyor

        const productImages = (row.photos || photos).map((photo) => {
          const imageBase64 = `data:image/png;base64,${photo.base64}`;
          return {
            ImageBase64: imageBase64,
            CreateDate: new Date().toISOString(),
            UpdateDate: new Date().toISOString(),
            IA: true,
          };
        });

        const productAttributes = Array.isArray(row?.combination)
          ? row.combination.map((attr, index) => ({
              productId: 0,
              attributeValueId: index,
              varyantible: true,
              ia: true,
              attributeValue: {
                attributeId: index,
                name: attr.option,
                ia: true,
                attribute: { userId, name: attr.name, ia: true },
              },
            }))
          : [];

        const productPrices = Object.keys(row?.prices || marketplaceValues).map(
          (marketplaceName) => {
            const marketplace = marketplaces.find(
              (m) => m.name === marketplaceName
            );
            const prices =
              row?.prices?.[marketplaceName] ||
              marketplaceValues[marketplaceName];
            return {
              productId: 0,
              marketPlaceId:
                marketplace?.source === "marketplace" ? marketplace.id : null,
              ecommercePlaceId:
                marketplace?.source === "ecommerce" ? marketplace.id : null,
              listPrice: parseFloat(prices?.["Piyasa(Liste Fiyatı)"] || 0),
              salePrice: parseFloat(prices?.["Satış Fiyatı"] || 0),
              barcode: prices?.["Barcode"] || "",
            };
          }
        );

        const productBarcodes = marketplaces.map((marketplace) => {
          const barcode =
            row?.prices?.[marketplace.name]?.["Barcode"] ||
            marketplaceValues[marketplace.name]?.["Barcode"] ||
            "";
          return {
            barcode: barcode,
            marketPlaceId:
              marketplace.source === "marketplace" ? marketplace.id : null,
            ecommercePlaceId:
              marketplace.source === "ecommerce" ? marketplace.id : null,
          };
        });

        return {
          brandId: parseInt(productDetails.brand, 10) || 0,
          userId: authUserId || 0,
          categoryId: parseInt(productDetails.category, 10) || 0,
          quantity: parseInt(productDetails.stock, 10) || 0,
          stockCode,
          productMainId,
          supplierBarcode: productDetails.supplierBarcode || "",
          title: productDetails.productName,
          description: description || "",
          ia: true,
          productAttributes,
          productImages,
          productPrices,
          productBarcodes,
          productStockHistories: [],
        };
      });

      console.log("productAddDTOs", productAddDTOs);

      setLoading(true);
      const response = await productService.addProduct(productAddDTOs, token);
      setLoading(false);
      showSuccessProductAdded();
    } catch (error) {
      setLoading(false);
      console.error("Error adding product:", error);
      showErrorProductAdded();
    }
  };

  const applyToAllFields = () => {
    setMarketplaceValues((prevValues) => {
      const updatedValues = marketplaces.reduce((acc, marketplace) => {
        acc[marketplace.name] = {
          "Piyasa(Liste Fiyatı)": piyasaFiyati || "",
          "Satış Fiyatı": satisFiyati || "",
        };
        return acc;
      }, {});
      return { ...prevValues, ...updatedValues };
    });
  };

  const applyBarcodeToAll = () => {
    setMarketplaceValues((prevValues) => {
      const updatedValues = marketplaces.reduce((acc, marketplace) => {
        acc[marketplace.name] = {
          ...prevValues[marketplace.name],
          Barcode: barcode || "",
        };
        return acc;
      }, {});
      return { ...prevValues, ...updatedValues };
    });
  };

  return (
    <Box
      sx={{
        width: "100%",
        padding: { xs: 1, sm: 2, md: 4 },
        backgroundColor: "#f5f5f5",
      }}
    >
      <Box
        sx={{
          padding: { xs: 1, sm: 2 },
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: { xs: 2, sm: 3 },
          backgroundColor: "#fff",
          borderRadius: 2,
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            sx={{ width: 4, height: 24, backgroundColor: "#b71c1c", mr: 1 }}
          />
          <Typography
            variant="h6"
            color="black"
            sx={{ textTransform: "uppercase", letterSpacing: "0.08em" }}
          >
            Ürün Oluştur
          </Typography>
        </Box>
      </Box>

      <form onSubmit={handleSubmit}>
        <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} md={9}>
            <Box
              sx={{
                padding: { xs: 1, sm: 2, md: 3 },
                backgroundColor: "#fff",
                borderRadius: 2,
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                paddingBottom: { xs: 10, sm: 16, md: 20 },
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: "500",
                  color: "#333",
                  textAlign: "left",
                  letterSpacing: "0.03em",
                  mb: 1,
                }}
              >
                Genel Bilgiler
              </Typography>
              <Grid container spacing={{ xs: 1, sm: 2 }}>
                {[
                  {
                    label: "Ürün Adı",
                    name: "productName",
                    value: productDetails.productName,
                  },
                  {
                    label: "Model Kodu",
                    name: "modelCode",
                    value: productDetails.modelCode,
                  },
                  {
                    label: "Satıcı Barcode",
                    name: "supplierBarcode",
                    value: productDetails.supplierBarcode,
                  },
                  { label: "Stok", name: "stock", value: productDetails.stock },
                ].map((field, index) => (
                  <Grid item xs={12} sm={6} key={index}>
                    <TextField
                      size="small"
                      fullWidth
                      label={field.label}
                      variant="outlined"
                      name={field.name}
                      value={field.value}
                      onChange={handleInputChange}
                      error={!!formErrors[field.name]}
                      helperText={formErrors[field.name]}
                    />
                  </Grid>
                ))}
              </Grid>
              <Typography
                variant="subtitle1"
                sx={{
                  mt: 3,
                  mb: 1,
                  fontWeight: "500",
                  color: "#333",
                  textAlign: "left",
                  letterSpacing: "0.03em",
                }}
              >
                Detaylı Açıklama
              </Typography>
              <Box
                sx={{
                  height: 200,
                  overflow: "auto",
                  border: `1px solid ${
                    formErrors.description ? "red" : "#ddd"
                  }`,
                  borderRadius: 2,
                  mb: 1,
                }}
              >
                <ReactQuill
                  value={description}
                  onChange={handleDescriptionChange}
                  theme="snow"
                  style={{ height: "80%" }}
                />
              </Box>
              {formErrors.description && (
                <Typography variant="caption" color="error">
                  {formErrors.description}
                </Typography>
              )}

              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                  gap: { xs: 1, sm: 2 },
                  mb: { xs: 2, sm: 3 },
                  mt: { xs: 2, sm: 3 },
                }}
              >
                <NestedCategorySelect
                  categories={categories}
                  value={productDetails.category}
                  onChange={(selectedValue) => {
                    setProductDetails((prev) => ({
                      ...prev,
                      category: selectedValue,
                    }));
                  }}
                  error={formErrors.category}
                />

                <FormControl size="small" fullWidth error={!!formErrors.brand}>
                  <InputLabel id="brand-select-label">Marka Seçiniz</InputLabel>
                  <Select
                    labelId="brand-select-label"
                    id="brand-select"
                    name="brand"
                    value={productDetails.brand}
                    onChange={handleInputChange}
                    label="Marka Seçiniz"
                  >
                    <MenuItem value="">
                      <em>Marka Seçiniz</em>
                    </MenuItem>
                    {brandsData?.map((brand) => (
                      <MenuItem key={brand.id} value={brand.id}>
                        {brand.name}
                      </MenuItem>
                    ))}
                  </Select>
                  {formErrors.brand && (
                    <Typography variant="caption" color="error">
                      {formErrors.brand}
                    </Typography>
                  )}
                </FormControl>
              </Box>

              {variantData?.variants?.length === 0 && (
                <PhotoUploader onPhotosChange={handlePhotosChange} />
              )}
            </Box>
          </Grid>

          <Grid item xs={12} md={3}>
            <div>
              <Accordion
                expanded={expanded === "panel1"}
                onChange={handleChange("panel1")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                  sx={{
                    fontWeight: "500",
                    color: "#333",
                    textAlign: "left",
                    letterSpacing: "0.03em",
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#fff",
                    zIndex: 100,
                    padding: "8px 16px",
                    backgroundColor: "#1F1B45",
                    borderTopLeftRadius: 8,
                    borderTopRightRadius: 8,
                    color: "white",
                  }}
                >
                  <Typography sx={{ width: "33%", flexShrink: 0 }}>
                    Fiyatlandırma
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Box
                    sx={{
                      padding: { xs: 1, sm: 2 },
                      backgroundColor: "#fff",
                      borderRadius: 2,
                      height: { xs: "auto", sm: 500 },
                      maxHeight: { xs: "400px", sm: "500px" },
                      overflowY: "auto",
                    }}
                  >
                    <TextField
                      size="small"
                      sx={{
                        mt: 1,
                      }}
                      fullWidth
                      label="Piyasa Fiyatı"
                      variant="outlined"
                      value={piyasaFiyati}
                      onChange={(e) => setPiyasaFiyati(e.target.value)}
                      error={!!formErrors.piyasaFiyati}
                      helperText={formErrors.piyasaFiyati}
                    />
                    <TextField
                      size="small"
                      sx={{
                        mt: 1,
                        mb: 3,
                      }}
                      fullWidth
                      label="Satış Fiyatı"
                      variant="outlined"
                      value={satisFiyati}
                      onChange={(e) => setSatisFiyati(e.target.value)}
                      error={!!formErrors.satisFiyati}
                      helperText={formErrors.satisFiyati}
                    />
                    <Button
                      fullWidth
                      variant="outlined"
                      onClick={applyToAllFields}
                      sx={{
                        mb: 3,
                        borderColor: "#332783",
                        borderRadius: 20,
                        color: "#332783",
                        "&:hover": {
                          borderColor: "#1565c0",
                          backgroundColor: "rgba(21, 101, 192, 0.1)",
                        },
                      }}
                    >
                      Tümüne Uygula
                    </Button>
                    {marketplaces.map((marketplace, index) => (
                      <Accordion key={index}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography
                            variant="subtitle1"
                            sx={{
                              fontWeight: "500",
                              color: marketplace.color,
                              textAlign: "left",
                              letterSpacing: "0.03em",
                            }}
                          >
                            {marketplace.name}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          {marketplace.fields.map((field, fieldIndex) => (
                            <TextField
                              size="small"
                              key={fieldIndex}
                              fullWidth
                              label={field}
                              variant="outlined"
                              value={
                                marketplaceValues[marketplace.name]?.[field] ||
                                ""
                              }
                              sx={{ mb: 3 }}
                              onChange={(e) =>
                                setMarketplaceValues((prevValues) => ({
                                  ...prevValues,
                                  [marketplace.name]: {
                                    ...prevValues[marketplace.name],
                                    [field]: e.target.value,
                                  },
                                }))
                              }
                            />
                          ))}
                        </AccordionDetails>
                      </Accordion>
                    ))}
                  </Box>
                </AccordionDetails>
              </Accordion>
              <Accordion
                sx={{ mt: 1 }}
                expanded={expanded === "panel2"}
                onChange={handleChange("panel2")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
                  aria-controls="panel2bh-content"
                  id="panel2bh-header"
                  sx={{
                    fontWeight: "500",
                    color: "#333",
                    textAlign: "left",
                    letterSpacing: "0.03em",
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#fff",
                    zIndex: 100,
                    backgroundColor: "#1F1B45",
                    color: "white",
                  }}
                >
                  <Typography sx={{ width: "33%", flexShrink: 0 }}>
                    Barcode
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Box
                    sx={{
                      padding: { xs: 1, sm: 2 },
                      backgroundColor: "#fff",
                      borderRadius: 2,
                      height: { xs: "auto", sm: 490 },
                      maxHeight: { xs: "400px", sm: "490px" },
                      overflowY: "auto",
                    }}
                  >
                    <TextField
                      size="small"
                      sx={{ mt: 1, mb: 3 }}
                      fullWidth
                      label="Barcode"
                      variant="outlined"
                      value={barcode}
                      onChange={(e) => setBarcode(e.target.value)}
                      error={!!formErrors.barcode}
                      helperText={formErrors.barcode}
                    />
                    <Button
                      fullWidth
                      variant="outlined"
                      onClick={applyBarcodeToAll}
                      sx={{
                        mb: 3,
                        borderColor: "#332783",
                        borderRadius: 20,
                        color: "#332783",
                        "&:hover": {
                          borderColor: "#1565c0",
                          backgroundColor: "rgba(21, 101, 192, 0.1)",
                        },
                      }}
                    >
                      Tümüne Uygula
                    </Button>
                    {marketplaces.map((marketplace, index) => (
                      <Accordion key={index}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography
                            variant="subtitle1"
                            sx={{
                              fontWeight: "500",
                              color: marketplace.color,
                              textAlign: "left",
                              letterSpacing: "0.03em",
                            }}
                          >
                            {marketplace.name}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <TextField
                            size="small"
                            fullWidth
                            label="Barcode"
                            variant="outlined"
                            value={
                              marketplaceValues[marketplace.name]?.Barcode || ""
                            }
                            sx={{ mb: 3 }}
                            onChange={(e) =>
                              setMarketplaceValues((prevValues) => ({
                                ...prevValues,
                                [marketplace.name]: {
                                  ...prevValues[marketplace.name],
                                  Barcode: e.target.value,
                                },
                              }))
                            }
                          />
                        </AccordionDetails>
                      </Accordion>
                    ))}
                  </Box>
                </AccordionDetails>
              </Accordion>
            </div>
          </Grid>

          <Grid item xs={12}>
            <Box
              sx={{
                position: "relative",
                padding: { xs: 1, sm: 2, md: 3 },
                backgroundColor: "#fff",
                borderRadius: 2,
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                pb: { xs: 10, sm: 12, md: 16 },
              }}
            >
              <ProductVariant
                onVariantsChange={handleVariantsChange}
                initialProductDetails={productDetails}
                initialPrices={marketplaceValues}
                setFormErrors={setFormErrors}
                productDetails={productDetails}
                barcode={barcode}
                piyasaFiyati={piyasaFiyati}
                satisFiyati={satisFiyati}
                description={description}
              />
              <Button
                type="submit"
                variant="contained"
                startIcon={<IoMdSave />}
                sx={{
                  position: "absolute",
                  bottom: { xs: "8px", sm: "16px" },
                  right: { xs: "8px", sm: "16px" },
                  width: { xs: "100%", sm: "auto" },
                  backgroundColor: "#29275D",
                  color: "#fff",
                  textTransform: "none",
                  borderRadius: "5px",
                  "&:hover": {
                    backgroundColor: "#1f1b45",
                  },
                }}
              >
                Kaydet
              </Button>
            </Box>
          </Grid>
        </Grid>
      </form>

      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default AddProductPage;
